export const ORG_RETIRED_MARKER = "__RETIRED__";

export const getOrganizationDisplayCode = (code) => {
  if (!code) return "";
  const index = code.indexOf(ORG_RETIRED_MARKER);
  return index >= 0 ? code.slice(0, index) : code;
};

export const isRetiredOrganizationCode = (code) => Boolean(code && code.includes(ORG_RETIRED_MARKER));

export const formatOrganizationProvider = (code, t) => {
  if (!code) return t("ccOrgTelephonyProviderUnset");
  return String(code).replace(/_/g, " ");
};

export const getOrganizationInitials = (name, code) => {
  const source = (name || code || "?").trim();
  const parts = source.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  }
  return source.slice(0, 2).toUpperCase();
};
